<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <kinva-doc-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import KinvaDocCrud from "./KinvaDocCrud";
    export default {
        name: "KinvaDoc",
        components: {KinvaDocCrud}
    }
</script>

<style scoped>

</style>

